import * as React from 'react';
import List from '../components/List';
import { Switch } from '@beehive/components';
import messages from 'messages';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import _ from 'lodash';
import { MENUS_REQUEST_ACTONS_MAPPING } from '../utils';
import { Dispatch, bindActionCreators } from 'redux';
import * as actions from 'modules/actions/lsProjectMove';
import className from 'classnames';

const MENU_KEY = MENUS_REQUEST_ACTONS_MAPPING['lsMyAdvance'];

class MyAdvance extends React.Component<any, any> {

  handleChange = (
    menuKey: string,
    option: { isChecked: boolean; id: string },
  ) => {
    const { changeFinishType } = this.props;
    const { isChecked, id } = option;
    changeFinishType(menuKey, { isChecked, id });
  }

  getColumns = () => {
    return {
      finished: {
        width: 150,
        render: (v: any, r: any, i: number) => {
          return (
            <div
              className={className('', {
                'is-deal': v,
                'need-to-deal': !v,
              })}
            >
              <span className="is-deal-with">
                {v ? (
                  <FormattedMessage {...messages.haveToDealWith} />
                ) : (
                  <FormattedMessage {...messages.toBeProcessed} />
                )}
              </span>
              <Switch
                on={v}
                onChange={(e: any) =>
                  this.handleChange(MENU_KEY, {
                    isChecked: !r.finished,
                    id: r.id,
                  })
                }
                size="small"
              />
            </div>
          );
        },
      },
    };
  }

  public render() {
    return (
      <List menuKey={MENU_KEY} getColumns={this.getColumns} {...this.props} />
    );
  }
}

const mapState2Props = (state: any, ownProps: any) => {
  const data = state.workbench[_.snakeCase(MENU_KEY)];
  return {
    data,
  };
};

export function mapDispatchToProps(dispatch: Dispatch<any>, ownProps: any) {
  return bindActionCreators(
    {
      changeFinishType: actions.changeFinishType,
    },
    dispatch,
  );
}

export default connect(mapState2Props, mapDispatchToProps)(MyAdvance);
